import { render, staticRenderFns } from "./unPublish.vue?vue&type=template&id=40a44e8c&scoped=true&"
import script from "./unPublish.vue?vue&type=script&lang=js&"
export * from "./unPublish.vue?vue&type=script&lang=js&"
import style0 from "./unPublish.vue?vue&type=style&index=0&id=40a44e8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a44e8c",
  null
  
)

export default component.exports